var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWorldVision02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fill: "currentColor",
    viewBox: "0 0 26.9 24.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18.3,
    cy: 18.8,
    r: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3 13.4c-3.8 0-7.1 2.2-8.4 5.4 1.3 3.1 4.6 5.4 8.4 5.4s7.1-2.2 8.4-5.4c-1.3-3.1-4.6-5.4-8.4-5.4zm0 8.3c-2.4 0-4.5-1.1-5.7-3 1.2-1.8 3.4-3 5.7-3s4.5 1.1 5.7 3c-1.2 1.9-3.3 3-5.7 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 23.8C9.6 23 8.8 22 8.1 21c-3.9-1.8-6.4-6.5-5.3-10.9l5.7 5.7h1.2v-3.6H7.5V9.7h2.4c.7 0 1.2-.6 1.2-1.2V6.1h2.4c1.3 0 2.4-1.1 2.4-2.4v-.4c3.4 1.3 5.7 4.6 6 8.2.9.2 1.7.7 2.4 1.1.1-4.9-3-9.6-7.5-11.4-4-1.8-9.1-1-12.4 1.9-8 7-3.8 19.9 6.6 21-.1-.1-.3-.2-.5-.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorldVision02);
export default __webpack_public_path__ + "static/media/ICON-WORLD-VISION-02.853c0b4eae10b548006d9a5c6cb62ab9.svg";
export { ForwardRef as ReactComponent };